export const GET_DASHBOARD_LOG_METRIC_DATA = 'GET_DASHBOARD_LOG_METRIC_DATA';
export const GET_DASHBOARD_EXCEPTION_METRIC_DATA = 'GET_DASHBOARD_EXCEPTION_METRIC_DATA';
export const GET_DASHBOARD_REPLAY_METRIC_DATA = 'GET_DASHBOARD_REPLAY_METRIC_DATA';
export const SET_DASHBOARD_METRIC_DATA = 'SET_DASHBOARD_METRIC_DATA';
